import { useQuery } from '@tanstack/react-query'
import { getFeatures, DEFAULT_FEATURES } from '../services/api/features'
import type { FeatureFlags } from '../types/api'

export const FEATURES_QUERY_KEY = ['features'] as const

/**
 * useFeatures — feature flags from GET /features. While loading (or when the
 * endpoint 404s) all `legacy_*` flags default to true so nothing disappears.
 */
export function useFeatures(): { features: FeatureFlags; isLoading: boolean; isEnabled: (key: string) => boolean } {
  const { data, isLoading } = useQuery({
    queryKey: FEATURES_QUERY_KEY,
    queryFn: getFeatures,
    staleTime: 5 * 60_000,
    retry: false,
  })
  const features = data ?? DEFAULT_FEATURES
  return {
    features,
    isLoading,
    isEnabled: (key: string) => features[key] ?? (key.startsWith('legacy_') ? true : false),
  }
}
